export default "__VITE_ASSET__D4ajKtdI__"